// extracted by mini-css-extract-plugin
module.exports = {"head":"value-module--head--CSVxp","values":"value-module--values--3BigH","valuesCard":"value-module--values-card--2zQ8S","image":"value-module--image--3zCuT"};